module.exports = __webpack_public_path__ + "img/76073.1dd0729d.svg";